import { OperationService, WalletService, CurrenciesService } from "@/services";

const ExchangeAutoComplete = () =>
  import(
    /* webpackChunkName: "ExchangeAutoComplete" */ "@/components/ExchangeAutoComplete/index"
  );
const CurrenciesAutoComplete = () =>
  import(
    /* webpackChunkName: "CurrenciesAutoComplete" */ "@/components/OperationsPage/Exchange/CurrenciesAutoComplete/index"
  );
const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");

const ExchangeInput = () =>
  import(
    /* webpackChunkName: "ExchangeInput" */ "@/components/OperationsPage/Exchange/ExchangeInput/index"
  );
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import dropRightWhile from "lodash-es/dropRightWhile";

import $thousandMask from "@/mixins/thousandMask";
import initService from "@/services/modules/initService";

export default {
  name: "exchange",
  components: {
    ExchangeAutoComplete,
    CurrenciesAutoComplete,
    Captcha,
    ExchangeInput
  },
  mixins: [$thousandMask],
  data() {
    return {
      activeButton: {
        all: false,
        half: false,
        min: false
      },
      almostTextTo: false,
      almostTextFrom: false,
      convertBtn: true,
      fromCurrency: {},
      fromValue: "",
      toCurrency: {},
      toValue: "",
      lastValidToValue: "",
      toExchanges: [],
      toValueRules: "",
      fromValueRules: "",
      isUpdating: false,
      balance: "",
      isSourceAmountFix: true,
      loading: false,
      isDisableSwitch: false,
      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false,
      fromCurrencies: [],
      toCurrencies: [],
      getWallets: {},
      exchanges: {},
      fromCurrencyDetails: {},
      toCurrencyDetails: {},
      userWallet: {},
      captchaStatus: false
    };
  },
  computed: {
    ...mapGetters({
      // currencies: types.currencies.getters.GET_CURRENCIES,
      // getWallets: types.operations.getters.GET_WALLET,
      // exchanges: types.wallets.getters.GET_EXCHANGE_WALLETS
    }),
    disabledBuyBtn() {
      return !(
        this.toValue !== "" &&
        this.toValue !== "0" &&
        this.fromValue !== "0" &&
        this.fromValue !== "" &&
        this.fromValueRules === "" &&
        this.toValueRules === ""
      );
    },
    // filterExchanges() {
    //   let list = [];
    //   if (this.currencies.length !== 0 && this.exchanges.length !== 0) {
    //     this.currencies.filter((el) => {
    //       let counter = 0;
    //       el.exchanges.filter((element) => {
    //         if (element.balance_balance === true) {
    //           counter++;
    //         }
    //       });
    //       if (counter !== 0) {
    //         list.push(el);
    //       }
    //     });
    //     return [];
    //   }
    // },

    rate() {
      if (this.fromCurrency === "IRR") {
        const result = this.calculateExchange(
          this.fromCurrencyDetails,
          this.toCurrencyDetails,
          0,
          1
        );

        const maskResult = this.$thousandMask(result);

        return `${this.toCurrency} 1 ≈ ${this.fromCurrency} ${maskResult}`;
      } else {
        const result = this.calculateExchange(
          this.fromCurrencyDetails,
          this.toCurrencyDetails,
          1
        );
        const maskResult = this.$thousandMask(result);
        return `${this.fromCurrency} 1 ≈ ${this.toCurrency} ${maskResult}`;
      }
    },

    pureFromValue() {
      return this.removeThousand(this.fromValue);
    },

    pureToValue() {
      return this.removeThousand(this.toValue);
    },

    fromCurrencyWallet() {
      if (this.fromCurrency && Object.entries(this.getWallets).length > 0) {
        return this.getWallets.wallets.find(elem => {
          if (elem.iso === this.fromCurrency.iso) {
            return elem;
          }
        });
      }
    }
  },
  mounted() {
    // this.getCurrenciesService();
    // this.getWalletService();
    // this.getExchangeService();
    this.getFromCurrencies();
    this.getCaptchaStatus();
  },
  methods: {
    ...mapActions({
      currenciesDataAction: types.currencies.actions.SET_CURRENCIES
    }),
    getCaptchaStatus() {
      initService.initSecurity().then(res => {
        this.captchaStatus = res.data.data.captcha.orders_exchange;
      });
    },
    allAmount() {
      this.fromValue = this.userWallet.balance.available;
      this.updateFromValue(this.fromValue);
      this.activeButton.min = false;
      this.activeButton.half = false;
      this.activeButton.all = true;
    },
    halfAmount() {
      if (this.userWallet.balance.available !== "0") {
        this.fromValue = (this.userWallet.balance.available / 2)
          .toFixed(this.fromCurrencyDetails.exponent)
          .toString();
        this.updateFromValue(this.fromValue);
      }
      this.activeButton.all = false;
      this.activeButton.min = false;
      this.activeButton.half = true;
    },
    minAmount() {
      this.toValue = this.toCurrencyDetails.limitation_amount.min;
      this.updateToValue(this.toValue);
      this.activeButton.all = false;
      this.activeButton.half = false;
      this.activeButton.min = true;
    },

    maxAmount(balance) {
      const set = amount => {
        const enDigit = this.toEnglishDigits(amount);
        const noComma = this.removeThousand(enDigit);
        const zeroChecked = this.leadingZero(noComma);
        const expo = this.exponent(this.fromCurrency, zeroChecked);
        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = expo.replace(".", "");
        if (isPositiveNumbers(withoutDot)) {
          const result = this.calculateExchange(
            this.fromCurrency,
            this.toCurrency,
            expo,
            0
          );
          this.toValue = result ? this.$thousandMask(result) : 0;
          this.fromValue = this.$thousandMask(noComma);
          this.showToValueRules(result, noComma);
        }
      };
      set(balance);
    },

    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    },

    calculateExchange(from, to, fromValue, toValue) {
      let fromPrice = 0;
      let toPrice = 0;

      /* USER WANTS TO BUY */
      if (from?.iso === "IRR") {
        fromPrice = from?.price?.global; /* we get user Rial */
        toPrice = to?.price.buy.amount; /* we sell crypto */

        /* USER WANTS TO SELL */
      } else if (to?.iso === "IRR") {
        fromPrice = from?.price.sell.amount; /* we buy user crypto */
        toPrice = to?.price.global; /* we pay Rial */

        /* USER WANTS TO CHANGE */
      } else {
        fromPrice = from?.price?.global; /* we buy user crypto */
        toPrice = to?.price?.change; /* we change crypto */
      }

      /* returns toValue */
      if (fromValue) {
        const result = (fromValue * fromPrice) / toPrice;
        return this.exponent(this.toCurrencyDetails, result);

        /* returns fromValue */
      } else if (toValue) {
        const result = (toValue * toPrice) / fromPrice;
        return this.exponent(this.fromCurrencyDetails, result);
      }
    },

    getResult(destination) {
      if (this.fromCurrency && this.toCurrency) {
        if (destination === "to") {
          return this.calculateExchange(
            this.fromCurrency,
            this.toCurrency,
            this.removeThousand(this.fromValue),
            0
          );
        } else if (destination === "from") {
          return this.calculateExchange(
            this.fromCurrency,
            this.toCurrency,
            0,
            this.removeThousand(this.toValue)
          );
        }
      }
    },

    changeFromCurrency(newCurrency) {
      this.activeButton.min = false;
      this.activeButton.half = false;
      this.activeButton.all = false;
      this.$router.push({ query: { from: newCurrency.iso } });
      this.updateFromCurrency(newCurrency);
    },

    // updateFromCurrency(newCurrency) {
    //   this.fromCurrency = newCurrency;
    //   this.updateToExchanges(newCurrency);
    //   let tempToCurrency = this.toCurrency;
    //
    //   if (!this.toExchanges.some((currency) => currency === tempToCurrency)) {
    //     this.toCurrency = this.toExchanges[0];
    //   }
    //   this.disableConvert(this.toCurrency, this.fromCurrency);
    //   // let des = this.toValue.length ? "from" : "to";
    //   const result = this.getResult("to");
    //   this.toValue = this.$thousandMask(result);
    //   this.showToValueRules(this.toValue, this.fromValue);
    // },

    disableConvert(to, from) {
      this.convertBtn = true;
      if (this.filterExchanges) {
        let toTemp = to;
        let fromTemp = from;
        this.filterExchanges.find(elem => {
          if (elem.iso === toTemp.iso) {
            this.convertBtn = false;
          }
        });
        if (
          Object.entries(from).length !== 0 &&
          Object.entries(to).length !== 0 &&
          !this.convertBtn
        ) {
          toTemp.exchanges.find(elem => {
            if (elem.to === fromTemp.iso) {
              this.convertBtn = !elem.balance_balance;
            }
          });
        }
      }
    },

    async updateFromValue(value) {
      this.almostTextTo = true;
      this.almostTextFrom = false;
      const set = async amount => {
        const enDigit = await this.toEnglishDigits(amount);
        const noComma = await this.removeThousand(enDigit);
        const zeroChecked = await this.leadingZero(noComma);
        const expo = await this.exponent(this.fromCurrencyDetails, zeroChecked);
        const isPositiveNumbers = async str => {
          const reg = await new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = await expo.replace(".", "");
        if (isPositiveNumbers(withoutDot)) {
          const result = await this.calculateExchange(
            this.fromCurrencyDetails,
            this.toCurrencyDetails,
            expo,
            0
          );
          this.toValue = (await result) ? await this.$thousandMask(result) : 0;
          this.fromValue = await this.$thousandMask(noComma);
          await this.showToValueRules(result, noComma);
        }
      };
      if (value) {
        this.fromValue = value;
        await set(value);
      } else {
        this.fromValue = "";
        this.toValue = "";
      }
      this.isSourceAmountFix = true;
    },

    updateToCurrency(newCurrency) {
      this.activeButton.min = false;
      this.activeButton.half = false;
      this.activeButton.all = false;

      this.toCurrencyDetails = this.toCurrencies.find(el => {
        return el.iso === newCurrency;
      });
      this.toCurrency = newCurrency;
      this.disableConvert(this.toCurrency, this.fromCurrency);
      const result = this.getResult("to");
      this.toValue = this.$thousandMask(result);
      this.showToValueRules(this.toValue, this.fromValue);
    },

    async updateToValue(value) {
      this.almostTextTo = false;
      this.almostTextFrom = true;
      const set = async amount => {
        const enDigit = await this.toEnglishDigits(amount);
        const noComma = await this.removeThousand(enDigit);
        const zeroChecked = await this.leadingZero(noComma);
        const expo = await this.exponent(this.toCurrencyDetails, zeroChecked);
        const isPositiveNumbers = async str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = expo.replace(".", "");
        if (isPositiveNumbers(withoutDot)) {
          const result = this.calculateExchange(
            this.fromCurrencyDetails,
            this.toCurrencyDetails,
            0,
            expo
          );
          this.fromValue = result ? this.$thousandMask(result) : 0;
          this.toValue = this.$thousandMask(noComma);
          this.showToValueRules(noComma, result);
        }
      };
      if (await value) {
        this.toValue = value;
        await set(value);
      } else {
        this.fromValue = "";
        this.toValue = "";
      }
      this.isSourceAmountFix = false;
    },

    updateToExchanges(newCurrency) {
      let currencyExchanges = newCurrency.exchanges;
      let tempExchanges = [];
      currencyExchanges.forEach(exchange => {
        this.currencies.find(elem => {
          if (elem.iso !== newCurrency.iso && elem.iso === exchange.to) {
            if (exchange.balance_balance) {
              tempExchanges.push(elem);
            }
          }
        });
      });
      this.toExchanges = tempExchanges;
    },

    exchangeSwitch() {
      this.activeButton.min = false;
      this.activeButton.half = false;
      this.activeButton.all = false;
      // const tempFromCurrency = this.fromCurrencyDetails;
      // const tempToCurrency = this.toCurrencyDetails;
      // this.fromCurrencyDetails = tempToCurrency;
      // this.fromCurrency = this.toCurrencyDetails.iso

      this.getToCurrency(this.toCurrencyDetails.iso, true).then(() => {
        this.fromValue = "";
        this.toValue = "";
      });

      // alert(this.fromValue)
      // this.showToValueRules(this.toValue, this.fromValue);

      // console.log(typeof this.fromValue)
      // console.log(this.toValue)
      // this.disableConvert(this.toCurrency, this.fromCurrency);
      //   ? this.$thousandMask(this.exponent(this.toCurrency, result))
      //   : 0;

      // if (
      //   this.toExchanges.some(currency => currency.iso === tempFromCurrency.iso)
      // ) {
      //   this.toCurrency = tempFromCurrency;
      // } else {
      //   this.toCurrency = this.toExchanges[0];
      // }
      // let currency = this.toCurrency.exchanges?.find(
      //   currency => currency.to === this.fromCurrency?.iso
      // );
    },
    // exchangeSwitch() {
    //   this.activeButton.min = false;
    //   this.activeButton.half = false;
    //   this.activeButton.all = false;
    //   const tempFromCurrency = this.fromCurrency;
    //   const tempToCurrency = this.toCurrency;
    //   this.fromCurrency = tempToCurrency;
    //   this.updateToExchanges(tempToCurrency);
    //   if (
    //     this.toExchanges.some(currency => currency.iso === tempFromCurrency.iso)
    //   ) {
    //     this.toCurrency = tempFromCurrency;
    //   } else {
    //     this.toCurrency = this.toExchanges[0];
    //   }
    //   let currency = this.toCurrency.exchanges?.find(
    //     currency => currency.to === this.fromCurrency?.iso
    //   );
    //   this.fromValue =
    //     this.removeThousand(this.fromValue) > currency.maximum_amount_to
    //       ? 0
    //       : this.$thousandMask(
    //           this.exponent(
    //             this.fromCurrency,
    //             this.removeThousand(this.fromValue)
    //           )
    //         );
    //   const result = this.calculateExchange(
    //     this.fromCurrency,
    //     this.toCurrency,
    //     this.removeThousand(this.fromValue),
    //     0
    //   );
    //   this.disableConvert(this.toCurrency, this.fromCurrency);
    //   this.toValue = result
    //     ? this.$thousandMask(this.exponent(this.toCurrency, result))
    //     : 0;
    //   this.showToValueRules(this.toValue, this.fromValue);
    // },

    buyCurrency() {
      this.loading = true;
      let data = {
        from_currency_id: this.fromCurrencyDetails.id,
        from_amount: this.fromValue
          ? this.removeThousand(this.fromValue)
          : this.fromValue,
        to_currency_id: this.toCurrencyDetails.id,
        to_amount: this.toValue
          ? this.removeThousand(this.toValue)
          : this.toValue,
        is_source_amount_fix: this.isSourceAmountFix,
        captcha_token: this.captcha_token,
        captcha_value: this.captcha_value
      };
      OperationService.exchangeGetToken(data)
        .then(response => {
          this.$router.push({
            path: `/submit-order/${response.data.data.token}/exchange`
          });
        })
        .catch(error => {
          this.captcha_token = null;
          this.captcha_value = null;
          this.captcha_hash = error.data.captcha_hash;
        })
        .finally(() => {
          this.loading = false;
          this.reloadCaptcha = !this.reloadCaptcha;
        });
    },

    showToValueRules(to, from) {
      if (to && from) {
        let currency = this.toCurrencyDetails;
        this.balance = this.userWallet.balance.available;
        if (parseFloat(this.removeThousand(from)) > parseFloat(this.balance)) {
          this.toValueRules = "";
          this.fromValueRules = this.$t(
            "operationsPage.exchange.balanceNotEnough"
          );
        } else if (
          parseFloat(this.removeThousand(to)) >
            parseFloat(currency.maximum_amount_to) &&
          parseFloat(this.removeThousand(from)) <= parseFloat(this.balance)
        ) {
          this.fromValueRules = "";
          this.toValueRules = this.$tc(
            "operationsPage.exchange.maxReceive",
            `${this.$thousandMask(currency.maximum_amount_to)} ${
              this.toCurrencyDetails?.iso
            }`
          );
        } else if (
          parseFloat(this.removeThousand(to)) <
            parseFloat(currency.minimum_amount_to) &&
          parseFloat(this.removeThousand(from)) < parseFloat(this.balance)
        ) {
          this.fromValueRules = "";
          this.toValueRules = this.$tc(
            "operationsPage.exchange.minReceive",
            `${this.$thousandMask(currency.minimum_amount_to)} ${
              this.toCurrencyDetails?.iso
            }`
          );
        } else {
          this.toValueRules = "";
          this.fromValueRules = "";
        }
      }
      // return value === "min" ? this.$thousandMask(currency.minimum_amount_to) : value === "max" && this.$thousandMask(currency.maximum_amount_to);
    },

    exponent(currency, value) {
      if (value) {
        const isNegative = number => {
          return number < 0;
        };

        const isInt = number => {
          return !number.includes(".");
        };

        const decimalsLength = float => {
          const arr = (float + "").split(".");
          return arr[1]?.length;
        };
        if (isNegative(value)) {
          return "";
        } else if (isInt(value.toString())) {
          return value;
        } else if (!isInt(value.toString())) {
          const { exponent } = currency;
          if (decimalsLength(value) <= exponent) {
            const str = value.toString();
            const spl = str?.split(".");
            const decimals = spl[1];
            const decimalsSplit = decimals?.split("");
            const dropped = dropRightWhile(
              decimalsSplit,
              number => number === "0"
            );
            return dropped?.length ? spl[0] + "." + dropped.join("") : spl[0];
          } else {
            /* remove  zeros in decimals 1.20000*/
            const float = parseFloat(value);
            const fixed = float?.toFixed(exponent);
            const spl = fixed?.split(".");
            const decimals = spl[1];
            const decimalsSplit = decimals?.split("");
            const dropped = dropRightWhile(
              decimalsSplit,
              number => number === "0"
            );
            /* if no decimals => remove . */
            return dropped?.length ? spl[0] + "." + dropped.join("") : spl[0];
          }
        }
      }
    },

    toEnglishDigits(value) {
      if (value) {
        const persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        return value
          .toString()
          .replace("٫", ".")
          .replace(/[۰-۹]/g, chr => {
            return persian.indexOf(chr);
          });
      }
    },

    removeThousand(str) {
      if (str) {
        return str.toString().replace(/,/gi, "");
      }
    },

    leadingZero(value) {
      if (value) {
        let number = value.toString();
        if (value.includes(".")) {
          while (number.charAt(0) === "0" && number.charAt(1) !== ".") {
            number = number.substring(1);
          }
        } else if (number.slice(-1) !== "0") {
          while (number.charAt(0) === "0") {
            number = number.substring(1);
          }
        }
        return number;
      }
    },

    getCurrenciesService() {
      CurrenciesService.getCurrencies().then(async response => {
        this.currencies = response.data.data;
        if (!this.$route.query.from) {
          this.$router.push({ query: { from: this.currencies[1].iso } });
        }
        this.currencies.find(elem => {
          if (elem.iso === this.$route.query.from) {
            this.updateFromCurrency(elem);
          }
        });
      });
    },
    getWalletService() {
      WalletService.getWalletV4().then(response => {
        this.getWallets = response.data.data;
        this.isWalletLoaded = true;
      });
    },
    getExchangeService() {
      WalletService.getExchanges().then(response => {
        this.exchanges = response.data.data;
        this.isExchangeLoaded = true;
      });
    },
    /////////////////////

    getFromCurrencies() {
      OperationService.getFromCurrenciesV2().then(res => {
        this.fromCurrencies = res.data.data;
        if (!this.$route.query.from) {
          this.fromCurrency = this.fromCurrencies[0].iso;
          this.$router.push({
            query: {
              from: this.fromCurrencies[0].iso
            }
          });
        } else {
          this.fromCurrency = this.$route.query.from;
        }
        this.getToCurrency(this.fromCurrency);
        this.getWalletDetails(this.fromCurrency);
      });
    },
    async getToCurrency(data, isSwitch = false) {
      if (this.$route.query.from !== data) {
        this.$router.push({ query: { from: data } });
      }
      this.isDisableSwitch = true;
      OperationService.getToCurrenciesV2(data).then(res => {
        this.toCurrencies = res.data.data.to_currencies;
        if (isSwitch) {
          let temp = this.fromCurrency;
          this.fromCurrency = this.toCurrency;
          this.toCurrency = temp;
        } else {
          this.fromCurrency = data;
          this.toCurrency = this.toCurrencies[0].iso;
        }

        this.fromCurrencyDetails = res.data.data.from_currency;
        this.getWalletDetails(data);
        this.updateToCurrency(this.toCurrency);
      });
    },
    getWalletDetails(iso) {
      WalletService.getWalletDetailsV2(iso).then(res => {
        this.userWallet = res.data.data;
      });
    }
  },
  watch: {
    async fromValue(newValue, oldValue) {
      if (await newValue) {
        let { exponent } = this.fromCurrency;
        let numberLength = newValue.toString().split(".")[1]
          ? newValue.toString().split(".")[1].length
          : 0;
        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        const withoutDot = newValue.replace(".", "");
        if (numberLength && numberLength > exponent) {
          this.fromValue = oldValue;
        } else if (exponent === 0 && newValue.includes(".")) {
          this.fromValue = oldValue.replace(".", "");
        }
        if (newValue[0] === "0") {
          if (newValue[1] && newValue[1] !== ".") {
            this.fromValue = "";
            this.toValue = "";
          }
        } else if (withoutDot.includes(".")) {
          this.fromValue = oldValue;
        } else if (!isPositiveNumbers(newValue)) {
          this.fromValue = oldValue;
        }
      }
    },
    async toValue(newValue, oldValue) {
      if (await newValue) {
        let { exponent } = this.toCurrency;
        let numberLength = newValue.toString().split(".")[1]
          ? newValue.toString().split(".")[1].length
          : 0;

        const isPositiveNumbers = str => {
          const reg = new RegExp(/^([0-9,.۰-۹٫])*$/);
          return reg.test(str);
        };
        if (numberLength && numberLength > exponent) {
          this.toValue = oldValue;
        } else if (exponent === 0 && newValue.includes(".")) {
          this.toValue = oldValue.replace(".", "");
        }
        if (newValue[0] === "0") {
          if (newValue[1] && newValue[1] !== ".") {
            this.fromValue = "";
            this.toValue = "";
          }
        } else if (!isPositiveNumbers(newValue)) {
          this.toValue = oldValue;
        }
      }
    },
    toCurrency(newValue) {
      const from = this.$route.query.from;
      const to = newValue;
      OperationService.getSwitchCurrenciesStatus(to, from).then(res => {
        this.isDisableSwitch = !res.data.data.change_activated;
      });
    }
  }
};
